/*eslint-disable */
import React from 'react';
import SvgIcon from './SvgIcon';

const Dotted = ({
  color, height, className,
} : any) => (
  <SvgIcon xmlns="http://www.w3.org/2000/svg" version="1.1" width={height * 2} height={height * 2} className={className}>
    <circle fill={color} r={height} cx={height} cy={height} />
  </SvgIcon>
);

export default Dotted;
